import { render, staticRenderFns } from "./MenuTreatment.vue?vue&type=template&id=2d350218&"
import script from "./MenuTreatment.vue?vue&type=script&lang=js&"
export * from "./MenuTreatment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports